import { withIsVisible } from "../../utils/reactUtils";
import styled from "@emotion/styled";

interface SpinnerProps {
  spinnerSize?: number;
}
export const Spinner = withIsVisible(styled.div<SpinnerProps>`
  width: ${props => (props.spinnerSize ? `${props.spinnerSize}px` : "20px")};
  height: ${props => (props.spinnerSize ? `${props.spinnerSize}px` : "20px")};
  display: inline-block;
  border: 2.5px solid rgb(255 255 255 / 50%);
  border-right-color: #d9d9d9;
  border-radius: 50%;
  vertical-align: middle;
  animation: 1s cubic-bezier(0.74, 0.03, 0.38, 1.01) infinite spinner-border;
  @keyframes spinner-border {
    to {
      transform: rotate(360deg);
    }
  }
`);
